import React from 'react';
import { Box, Heading } from '@chakra-ui/react';

const isListItemEmpty = listItem => Object.keys(listItem).length < 1;

const isListEmpty = (list = {}) => !Object.values(list).some(i => !isListItemEmpty(i));

export const PrintEE = ({
  education,
  experience,
  adresses,
  trips,
  relatives,
}) => {
  const noEducation = isListEmpty(education);
  const noExperience = isListEmpty(experience);
  const noAddresses = isListEmpty(adresses);
  const noTrips = isListEmpty(trips);
  const noRelatives = isListEmpty(relatives);
  return (
    <Box>
      {!noEducation && (
        <>
          <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
            Education
          </Heading>
          {Object.values(education).map(
            (item, i) =>
              !isListItemEmpty(item) && (
                <Box key={String(i)}>
                  <Box>
                    <strong>Name:</strong>
                    {` ${item.name} `}
                    <strong>City:</strong>
                    {` ${item.city} `}
                  </Box>
                  <Box>
                    <strong>Started:</strong>
                    {` ${item.startDate} `}
                    <strong>Ended:</strong>
                    {` ${item.endDate} `}
                  </Box>
                  <Box>
                    <strong>Degree:</strong>
                    {` ${item.degree} `}
                    <strong>Specialization:</strong>
                    {` ${item.specialization} `}
                    <strong>Tuition form:</strong>
                    {` ${item.tuitionForm} `}
                  </Box>
                </Box>
              )
          )}
        </>
      )}
      {!noExperience && (
        <>
          <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
            Experience
          </Heading>
          {Object.values(experience).map(
            (item, i) =>
              !isListItemEmpty(item) && (
                <Box pb={4} key={String(i)}>
                  <Box>
                    <strong>Name:</strong>
                    {` ${item.name} `}
                    <strong>Title:</strong>
                    {` ${item.title} `}
                    <strong>Hours per week:</strong>
                    {` ${item.hoursPerWeek} `}
                  </Box>
                  <Box>
                    <strong>Country:</strong>
                    {` ${item.country} `}
                    <strong>City:</strong>
                    {` ${item.city} `}
                  </Box>
                  <Box>
                    <strong>Started:</strong>
                    {` ${item.startDate} `}
                    <strong>Ended:</strong>
                    {` ${item.isCurrent ? 'till now' : item.endDate} `}
                  </Box>
                </Box>
              )
          )}
        </>
      )}
      {!noAddresses && (
        <>
          <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
            Residence addresses
          </Heading>
          {Object.values(adresses).map(
            (item, i) =>
              !isListItemEmpty(item) && (
                <Box pb={4} key={String(i)}>
                  <Box>
                    <strong>ZIP:</strong>
                    {` ${item.zip} `}
                    <strong>Address:</strong>
                    {` ${item.address} `}
                  </Box>
                  <Box>
                    <strong>Started:</strong>
                    {` ${item.startDate} `}
                    <strong>Ended:</strong>
                    {` ${item.endDate} `}
                  </Box>
                </Box>
              )
          )}
        </>
      )}
      {!noTrips && (
        <>
          <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
            Trips abroad
          </Heading>
          {Object.values(trips).map(
            (item, i) =>
              !isListItemEmpty(item) && (
                <Box pb={4} key={String(i)}>
                  <Box>
                    <strong>Country:</strong>
                    {` ${item.country} `}
                    <strong>City:</strong>
                    {` ${item.city} `}
                    <strong>Purpose:</strong>
                    {` ${item.purpose} `}
                  </Box>
                  <Box>
                    <strong>Started:</strong>
                    {` ${item.startDate} `}
                    <strong>Ended:</strong>
                    {` ${item.endDate} `}
                  </Box>
                </Box>
              )
          )}
        </>
      )}
      {!noRelatives && (
        <>
          <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
            Relatives
          </Heading>
          {Object.values(relatives).map(
            (item, i) =>
              !isListItemEmpty(item) && (
                <Box pb={4} key={String(i)}>
                  <Box>
                    <strong>First name:</strong>
                    {` ${item.firstName} `}
                    <strong>Last name:</strong>
                    {` ${item.lastName} `}
                    <strong>Relationship:</strong>
                    {` ${item.relationship} `}
                  </Box>
                  <Box>
                    <strong>Birth Country:</strong>
                    {` ${item.birthCountry} `}
                    <strong>Residence Country:</strong>
                    {` ${item.residenceCountry} `}
                    <strong>City:</strong>
                    {` ${item.city} `}
                  </Box>
                  <Box>
                    <strong>Birth date:</strong>
                    {` ${item.birthDate} `}
                    <strong>Death date:</strong>
                    {` ${item.deathDate} `}
                  </Box>
                </Box>
              )
          )}
        </>
      )}
    </Box>
  );
};
